import _isArray from 'lodash/isArray'

const sortItems = (items: any[], ids: number[]) => {
  if (!_isArray(items)) return [items]

  const orderedItem: any = []
  const order = (id: number) => {
    const itemIndex = items.findIndex((item: { id: number }) => item.id === id)
    orderedItem.push(items[itemIndex])
  }
  ids.forEach(order)
  return orderedItem.filter((item: any) => !!item)
}

export default sortItems
